import React from 'react';
import { Stepper, Step, StepButton } from '@material-ui/core';
import FormAccess from './FormAccess';
import { registrationForms } from '../AccountRegistration/Data/defaults';
import Logo from '../AccountRegistration/Common/Logo';

export default function Register() {
  return (
    <div className="register-w">
      <div className="register-h">
        <div className="grd-cell-none">
          <Logo />
        </div>
        <div>
          <div className="stepper-w">
            <Stepper nonLinear activeStep={0} alternativeLabel>
              <Step key={0}>
                <StepButton disabled>Access</StepButton>
              </Step>
              {registrationForms.map((form, index) => {
                return (
                  <Step key={index}>
                    <StepButton disabled={true} completed={form.isCompleted}>
                      {form.label}
                    </StepButton>
                  </Step>
                );
              })}
            </Stepper>
          </div>
        </div>
      </div>
      <FormAccess />
    </div>
  );
}
